import React, {Component} from 'react';
import {
  FormFeedback as ReactStrapFormFeedback
} from 'reactstrap';

class FormFeedback extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <ReactStrapFormFeedback>
        {this.props.errors.map((error, index) => {
          return (<div key={index}>{error}</div>);
        })}
      </ReactStrapFormFeedback>
    );
  }
}

FormFeedback.defaultProps = {
  errors: []
}

export default FormFeedback;


// WEBPACK FOOTER //
// ./src/components/SmartForm/FormFeedback.js